import React, {FC} from 'react';
import Button from 'components/Button';
import DynamicAsset from 'components/DynamicAsset';
import {BG} from 'constants/index';
import {navigate} from 'gatsby';

import * as styles from './styles.module.scss';

export interface PanelWithTabsItemProps {
name: string;
title?: string;
text?: string;
imageSrc: string;
buttonText?: string;
buttonLink?: string;
bg?: BG
}

const PanelWithTabsItem: FC<PanelWithTabsItemProps> = ({
	title,
	text,
	imageSrc,
	buttonText,
	buttonLink,
	bg,
}) => {
	function handleClick(): void {
		if (buttonLink) {
			navigate(buttonLink);
		}
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<h6>{title}</h6>
				<p>{text}</p>
				{buttonLink && buttonText &&
					<Button
						type='button'
						variant={bg !== BG.dark ? 'primary' : 'light'}
						onClick={handleClick}
					>
						{buttonText}
					</Button>}
			</div>
			<div className={styles.image}>
				<DynamicAsset imageSrc={imageSrc} alt='Panel Item' />
			</div>
		</div>
	);

};

export default PanelWithTabsItem;
